import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["filename"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { AppAlertsContext } from '@infl-ts/ui-app-alerts';
import { convertToSupportedLang } from '@infl-ts/util-date';
import { generateRandomFilename } from '@infl-ts/util-generate-random-filename';
import { useToggle } from '@infl-ts/util-hooks';
import { toStaticUrl } from '@infl-ts/util-to-static-url';
import { Box, Button, InputLabel } from '@mui/material';
import { Filestack } from 'filestack-js';
import { flow, pipe } from 'fp-ts/function';
import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FILESTACK_API_KEY, NODE_ENV, PRIVATE_S3_BUCKET } from '../../env'; // AI-GEN - Cursor GPT4

import { Avatar } from '../avatar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var FilePickerComponent = function FilePickerComponent(_ref) {
  var clientOptions = _ref.clientOptions,
      handleUpload = _ref.handleUpload;

  var _useContext = useContext(AppAlertsContext),
      showAlert = _useContext.showAlert;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  var onUploadCompleted = function onUploadCompleted(uploadedFile) {
    if (uploadedFile) {
      pipe(toStaticUrl(_objectSpread(_objectSpread({}, uploadedFile), {}, {
        mediaType: 'image'
      }), NODE_ENV), function (file) {
        return handleUpload({
          url: file.url,
          filestack: {
            handle: file.handle
          }
        });
      });
    } else {
      console.error('failed to upload image');
      showAlert({
        severity: 'error',
        message: t('Sorry, we were unable to save your profile image'),
        duration: 'medium'
      });
    }
  };

  var picker = Filestack(FILESTACK_API_KEY, clientOptions).picker({
    onFileSelected: function onFileSelected(_ref2) {
      var filename = _ref2.filename,
          file = _objectWithoutProperties(_ref2, _excluded);

      return Promise.resolve(_objectSpread(_objectSpread({}, file), {}, {
        filename: generateRandomFilename(filename)
      }));
    },
    onFileUploadFinished: function onFileUploadFinished(file) {
      return onUploadCompleted(file);
    },
    rootId: 'FilePickerContainer',
    lang: convertToSupportedLang(i18n.language),
    maxSize: 10 * 1024 * 1024,
    accept: 'image/*',
    fromSources: ['local_file_system', 'imagesearch', 'unsplash', 'googledrive', 'dropbox', 'box', 'gmail', 'facebook', 'instagram'],
    uploadInBackground: false,
    storeTo: {
      location: 's3',
      container: PRIVATE_S3_BUCKET,
      // AI-GEN - Cursor GPT4
      //TODO: Use a path of this format: files/{hub.id}/{profile.id}/{getStorePath(acceptedMediaType)}
      path: 'files/temporary/images/',
      access: 'private',
      region: 'us-east-1'
    }
  });
  useEffect(function () {
    void picker.open()["catch"](function (error) {
      console.error(error);
    });
    return function () {
      if (picker) void picker.close();
    };
  }, []);
  return null;
};

var PureImageFormSection = function PureImageFormSection(_ref3) {
  var member = _ref3.member,
      handleImageUpload = _ref3.handleImageUpload,
      isOpen = _ref3.isOpen,
      toggle = _ref3.toggle,
      buttonOrientation = _ref3.buttonOrientation,
      t = _ref3.t;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      mb: 4
    },
    "data-element": "Box",
    "data-component": "PureImageFormSection",
    "data-source-file": "index.tsx",
    children: [isOpen && /*#__PURE__*/_jsx(FilePickerComponent, {
      handleUpload: handleImageUpload
    }), /*#__PURE__*/_jsx(Avatar, {
      size: "large",
      disabledPopover: true,
      member: member,
      "data-element": "Avatar",
      "data-component": "PureImageFormSection",
      "data-source-file": "index.tsx"
    }), /*#__PURE__*/_jsxs(Box, {
      sx: {
        ml: 5,
        display: 'flex',
        flexDirection: {
          sm: 'column',
          md: buttonOrientation
        },
        alignItems: {
          sm: 'flex-start',
          md: 'center'
        }
      },
      "data-element": "Box",
      "data-source-file": "index.tsx",
      children: [/*#__PURE__*/_jsx(InputLabel, {
        htmlFor: "fileupload",
        "data-element": "InputLabel",
        "data-source-file": "index.tsx",
        children: /*#__PURE__*/_jsx(Button, {
          onClick: toggle,
          id: "picker",
          size: "small",
          variant: "outlined",
          component: "span",
          "data-element": "Button",
          "data-source-file": "index.tsx",
          children: t('Upload new photo')
        })
      }), member.avatarUrl ? /*#__PURE__*/_jsx(Button, {
        sx: {
          ml: {
            sm: 0,
            md: buttonOrientation === 'column' ? 0 : 2.5
          }
        },
        variant: "text",
        onClick: function onClick() {
          return handleImageUpload({
            url: ''
          });
        },
        children: t('Remove')
      }) : null]
    })]
  });
};

var useProps = function useProps(_ref4) {
  var member = _ref4.member,
      _ref4$buttonOrientati = _ref4.buttonOrientation,
      buttonOrientation = _ref4$buttonOrientati === void 0 ? 'row' : _ref4$buttonOrientati,
      onUpload = _ref4.onUpload;

  var _useToggle = useToggle(),
      _useToggle2 = _slicedToArray(_useToggle, 2),
      isOpen = _useToggle2[0],
      _useToggle2$ = _useToggle2[1],
      closeFileStack = _useToggle2$.off,
      toggle = _useToggle2$.toggle;

  var _useTranslation2 = useTranslation(),
      t = _useTranslation2.t;

  var handleImageUpload = function handleImageUpload(newImage) {
    onUpload && onUpload(newImage.url);
    closeFileStack();
  };

  return {
    handleImageUpload: handleImageUpload,
    member: member,
    isOpen: isOpen,
    toggle: toggle,
    buttonOrientation: buttonOrientation,
    t: t
  };
};

export var ImageUpload = flow(useProps, PureImageFormSection);